import { render, staticRenderFns } from "./PositionPending.vue?vue&type=template&id=347984fa&"
import script from "./PositionPending.vue?vue&type=script&lang=js&"
export * from "./PositionPending.vue?vue&type=script&lang=js&"
import style0 from "./PositionPending.vue?vue&type=style&index=0&id=347984fa&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports